import { useEffect, useState } from "react";
import { DashboardSummaryRow } from "../../types/DashboardSummaryRow";
import { useIotGatewayEvents } from "./useIotGatewayEvents";
import { IotGatewayEventSummaryDto } from "./dtos/IotGatewayEventSummaryDto";
import { iotGatewayEvents } from "../../data/iotGatewayEvents.data";
import { DashboardSummary } from "../../components/DashboardSummary";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { useVspPortalCookies } from "../../hooks/useVspPortalCookies";
import { Dashboard } from "../../enums/Dashboard";


const compareDashboardSummaryRows = ( a: DashboardSummaryRow, b: DashboardSummaryRow ) => {

   
    if ( a.item < b.item ){
      
        return -1;

    }
    
    if ( a.item > b.item ){
      
        return 1;

    }

    return 0;

}


const getRows = ( iotGatewayEventsSummary: IotGatewayEventSummaryDto[] ): DashboardSummaryRow[] => {

    const rows: DashboardSummaryRow[] = [];

    for( const iotGatewayEventSummary of iotGatewayEventsSummary ) {

        rows.push( { count: iotGatewayEventSummary.gatewayCount, icon: <QuestionMarkIcon />, text: '', item: iotGatewayEventSummary.status  } );

    }

    // missing events
    const events = rows.map( r => r.item );
    for( const iotGatewayEvent of iotGatewayEvents ) {

        if( !events.includes( iotGatewayEvent.event )) {

            rows.push( { count: 0, icon: <QuestionMarkIcon />, text: '', item: iotGatewayEvent.event  } );

        }

    }

    // sorting
    rows.sort( compareDashboardSummaryRows );

    // formatting
    const formattedRows: DashboardSummaryRow[ ] = [ ];

    for( const row of rows ) {

        const iotGatewayEvent = iotGatewayEvents.find( be => be.event === row.item );

        if( !iotGatewayEvent ) {
            
            throw Error( `Iot Gateway event ${row.item} not found` );

        }

        formattedRows.push ({ 
            count: row.count,
            icon: iotGatewayEvent.icon,
            text: iotGatewayEvent.displayedText,
            item: row.item 
        });

    }

    return formattedRows;

};


type IotGatewayEventsSummaryProps = {

    onEventsSelected( events: string[ ] ): void;
    refreshCount: number;
    villageCode: string;

};


export const IotGatewayEventsSummary: React.FC<IotGatewayEventsSummaryProps> = ( props: IotGatewayEventsSummaryProps ) => {

    const { onEventsSelected, refreshCount, villageCode } = props;

    const [ selectedEvents, setSelectedEvents ] = useState< string[] >( [] );
    const [ rows, setRows ] = useState<DashboardSummaryRow[ ]>( [ ] );
    const [ isLoading, setIsLoading ] = useState<boolean>( false );


    const { getIotGatewayEventsSummary } = useIotGatewayEvents( );

    const { getEventsCookies, getVillageCookies } = useVspPortalCookies( );


    useEffect( ( ) => {

        if( !villageCode ) {

            return;

        }
        
        const fetchIotGatewayEventsSummary = async ( ) => {

            if( refreshCount === 0 ) {
                
                setIsLoading( true );
            }

            const eventsSummary = await getIotGatewayEventsSummary( villageCode );
            
            if( refreshCount === 0 ) {
            
                setIsLoading( false );

            }

            if( eventsSummary && eventsSummary.length > 0 ) {
                
                const rows: DashboardSummaryRow[] = getRows( eventsSummary ); 
                setRows( rows );

                const villageCookie = getVillageCookies( Dashboard.IotGateway );
                const iotGatewayEvents = getEventsCookies( Dashboard.IotGateway );
                
                if( villageCookie && villageCookie === villageCode && iotGatewayEvents ) {

                    setSelectedEvents( iotGatewayEvents );
                    onEventsSelected( iotGatewayEvents );
        
                } else {

                    setSelectedEvents( [] );    

                }

            } else {

                setRows( [] );
                setSelectedEvents( [] );

            }

        };
        
        fetchIotGatewayEventsSummary( );

    }, [ villageCode, refreshCount ]);


    return (

        <DashboardSummary header="Status" footer="No Of Gateways" isLoading={isLoading} refreshCount={refreshCount} rows={rows} checkedItems={ selectedEvents } disabledItems={ [ ] } onItemsSelected={onEventsSelected} />

    );

};